import { School } from '../school';
import { Student } from '../student';

export const enum StudentCommentType {
    'HEALTH',
    'INSTRUCTION',
    'FINANTIAL',
    'OTHER'
}

export const enum StudentCommentStatus {
    'OPEN',
    'DISMISSED'
}

export class StudentComment {
    constructor(
        public id?: number,
        public school?: School,
        public student?: Student,
        public content?: string,
        public type?: StudentCommentType,
        public status?: StudentCommentStatus
    ) {
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment.model.ts